import { Component, OnInit, ViewChild } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import moment  from 'moment';

const pdfMake = require('pdfmake/build/pdfmake.js');
import pdfFonts from 'pdfmake/build/vfs_fonts';
import {FACTURA} from 'src/app/constants/constants';
import { DatePipe } from '@angular/common';

//Servicios
import { FacturacionService } from 'src/app/services/facturacion.service';

@Component({
  selector: 'app-facturacion',
  templateUrl: './facturacion.component.html',
  styleUrls: ['./facturacion.component.scss']
})
export class FacturacionComponent implements OnInit {
  public dataSource: any
  public tableColumns: String[]
  public invitaciones: any
  public facturas: any
  public loading: any
  public filterValue?: string
  backgroundFactura:any
  pipe:any
  datosFiscales:any
  texto: any

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  constructor(public dialog: MatDialog, private apollo: Apollo, private facturaService: FacturacionService,) {
    this.tableColumns = [ 'numeroFactura', 'numOperacion', 'concepto', 'contratista.nombreComercial' , 'cliente.nombreComercial', 'precioTotal', 'fechaConfirmacion', 'numeroLicencias', 'descargar']
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    this.backgroundFactura = FACTURA
    this.pipe = new DatePipe('en-US');
   }

  ngOnInit(): void {
    this.getAllFacturas()
  }

  getAllFacturas(){
    this.apollo.watchQuery<any>({
      query: this.facturaService.getAllFacturas(),
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
        this.invitaciones = data.facturas
        this.facturas = this.invitaciones.filter((factura: any)=> factura.estado === "factura")
        /* console.log(this.facturas); */
        
        this.setDataTableOptions()
      })
  }

  setDataTableOptions(){
    this.dataSource = new MatTableDataSource(this.facturas)
    this.dataSource.paginator = this.paginator;   
    this.dataSource.sort = this.sort;
   /* this.dataSource.sortingDataAccessor = (item: any, property: any) => {
      return this.sortingData(item, property)
    };
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return this.filterPredicate(data, filter)
    }  */
  }

  generatePdf(nFactura:any, fecha:any, cantidad:any, concepto:any, unidad:any, base:any, iva:any, total:any, formaPago: any, contratista:any){  
    this.datosFiscales ='Razón social: ' + contratista.razonSocial + '\n' + 'CIF: ' +contratista.cif + '\n' + 'Dirección: ' + contratista.direccion.nombre 
    + ' ' + contratista.direccion.numero + '\n' + contratista.direccion.localidad + '\n' + contratista.direccion.provincia + '\n' 
    + contratista.direccion.codigoPostal
    
    const nFecha = this.pipe.transform(fecha, 'dd/MM/YY')
    const importeIva = (base * iva)/100
    
    const documentDefinition = { 
      custompageSize: {
        width: 210,
        heigth: 297
      },
      background:[{image: this.backgroundFactura,
        width: 600,
        heigth: 687}],
        info: {
          title: 'factura',
        },
      content: 
        [
          {text: nFactura, style:'idFactura'},
          {text: nFecha, style:'fecha'},
          {text: this.datosFiscales, style:'datos'},
          {text: cantidad, style:'cantidad'},
          {text: concepto, style:'concepto'},
          {text: unidad+'€', style:'unidad'},
          {text: base+'€', style:'total'},
          {text: base+'€', style:'imponible'},
          {text: iva+'%', style:'iva'},
          {text: importeIva+'€', style:'importeIva'},
          {text: formaPago, style: 'formaPago'},
          {text: total+'€', style:'totaliva'},
        ],

        styles:{
          idFactura:{
            margin:[380,2,0,0]
          },
          fecha:{
            margin:[463,-10,0,0]
          },
          datos:{
            margin:[0,90,0,0]
          },
          cantidad:{
            margin:[25,90,0,0]
          },
          concepto:{
            margin:[80,-15,0,0]
          },
          unidad:{
            margin:[350,-15,0,0]
          },
          total:{
            margin:[460,-15,0,0]
          },
          imponible:{
            margin:[25,145,0,0]
          },
          iva:{
            margin:[110,-15,0,0]
          },
           formaPago:{
            margin:[25,90,0,0]
          },
          totaliva:{
            margin:[410,-10,0,0]
          }
        }
      
    };
    pdfMake.createPdf(documentDefinition).open();
   }



  exportAsExcel() {
    
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("Facturas");
    let header = ['Número Factura', 'Código Operación Banco', 'Tipo producto', 'Contratista' , 'Cliente', 'Importe', 'Fecha Pago', 'Número Licencias']
    let headerRow = worksheet.addRow(header);

    for (let factura of this.facturas) {
      let temp = []
    
      // MAPEADO //
      temp.push(factura["numeroFactura"])
      temp.push(factura["numOperacion"])
      temp.push(factura["concepto"])
      temp.push(factura["contratista"] ? factura["contratista"]["nombreComercial"]: '')
      temp.push(factura["cliente"] ? factura["cliente"]["nombreComercial"]: '')
      temp.push(factura["precioTotal"])
      temp.push(factura["fechaConfirmacion"])
      temp.push(factura["numeroLicencias"])
        
      worksheet.addRow(temp)
     
    }

    let fname = "Tabla Facturas"

    workbook.xlsx.writeBuffer().then((data) => {

      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, fname + '-' + new Date().valueOf() + '.xlsx');
    });
  }
}
